require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-jeffrey-horn.json") })
        }
      }, "path---blog-author-jeffrey-horn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-jeffrey-horn!./.cache/json/blog-author-jeffrey-horn.json
// module id = 660
// module chunks = 231608221292675